import { gsap, ScrollTrigger } from "./gsap";

const BP_MOBILE = 1024;

export function initCta() {
  document.querySelectorAll("[data-cta]").forEach((section) => {
    initCtaSticky(section);
  });
}

function initCtaSticky(section) {
  const center = section.querySelector(".cta-section__center-wrap");
  const left = section.querySelector(".cta-section__img-wrap--left");
  const right = section.querySelector(".cta-section__img-wrap--right");

  if (!center || !right) return;

  let p1 = 0; // scrollY: center midpoint hits viewport midpoint
  let pLeft = 0; // scrollY: left top aligns with center top (viewport)
  let p3 = 0; // scrollY: right bottom aligns with center bottom (viewport)

  function measure() {
    gsap.set(center, { clearProps: "y" });
    if (left) gsap.set(left, { clearProps: "y" });

    const scrollY = window.scrollY;
    const vh = window.innerHeight;
    const centerRect = center.getBoundingClientRect();
    const rightRect = right.getBoundingClientRect();
    const centerTop = centerRect.top + scrollY;
    const centerH = centerRect.height;
    const rightBottom = rightRect.bottom + scrollY;

    p1 = centerTop + centerH / 2 - vh / 2;
    p3 = rightBottom - vh / 2 - centerH / 2;

    if (left) {
      const leftTop = left.getBoundingClientRect().top + scrollY;
      // left's top reaches center's top in viewport (center top = vh/2 - centerH/2)
      pLeft = leftTop - vh / 2 + centerH / 2;
    }
  }

  function update() {
    if (window.innerWidth <= BP_MOBILE) {
      gsap.set(center, { clearProps: "y" });
      if (left) gsap.set(left, { clearProps: "y" });
      return;
    }

    const scrollY = window.scrollY;

    // center
    let ty = 0;
    if (scrollY >= p3) ty = p3 - p1;
    else if (scrollY >= p1) ty = scrollY - p1;
    gsap.set(center, { y: ty });

    // left
    if (left) {
      let tyLeft = 0;
      if (scrollY >= p3) tyLeft = p3 - pLeft;
      else if (scrollY >= pLeft) tyLeft = scrollY - pLeft;
      gsap.set(left, { y: tyLeft });
    }
  }

  measure();
  update();

  ScrollTrigger.create({
    trigger: section,
    start: "top bottom",
    end: "bottom top",
    onUpdate: update,
    onRefresh: () => {
      measure();
      update();
    },
  });
}
